module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/joost/repositories/mobile-water/apotheken/polseweg/polseweg-frontend/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0